import { call, put } from 'redux-saga/effects';
import GetTypesActions from '../redux/GetTypesRedux';
import { api } from './api';


export function* gettypessagas(action: any): Generator<any, void, any> {
  const { children_id } = action;
  const response = yield call(api.getListtypes, children_id);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(GetTypesActions.getTypesSuccess(response.data));
  } else {
    yield put(GetTypesActions.getTypesFailure());
  }
}